<template>
  <div>
    <b-form-file
      :index="index"
      :multiple="multiple"
      :otherDocName="otherDocName"
      :documentLink="documentLink"
      :folderName="'Expense'"
      :accept="'*'"
      :documentName="documentName"
      :fileAllModuleId="fileAllModuleId"
      :assign_no="assign_no"
      placeholder="Choose a file or drop it here..."
      @change="handleFileChange"
    ></b-form-file>
    <div v-for="(ufile, uindex) in uploadedFiles" :key="uindex">
      <a
        v-if="assign_no"
        href="javascript:void(0)"
        @click="viewDoc(ufile)"
        >--View Document - {{ uindex + 1 }}</a
      >
    </div>
    <!-- <input type="file" :multiple="multiple" @change="handleFileUpload" /> -->
    <div v-for="(file, index) in files" :key="index">
      <div>{{ file.name }}</div>
      <b-progress
        v-if="file.progress > 0"
        :variant="'success'"
        :value="file.progress"
        :max="100"
        show-progress
        animated
      ></b-progress>
      <!-- <b-progress :value="file.progress" max="100"></b-progress> -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant";
export default {
  props: {
    index: {
      type: Number,
      default: 0,
    },
    second_index: {
      type: Number,
      default: 0,
    },
    assign_no: {
      type: String,
      default: "",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
      default: "",
    },
    documentName: {
      type: String,
      default: "",
    },
    otherDocName: {
      type: String,
      default: "",
    },
    documentLink: {
      type: String,
      default: "",
    },
    folderName: {
      type: String,
      default: "",
    },
    fileAllModuleId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      docURL: URL_BASE_DOC,
      uploadedFiles: [],
      presignedUrls: [],

      files: [],
      fileData: "",
      fileuploaded: "",
      fileEvent: "",
    };
  },
  computed: {
    doc_path() {
      return this.assign_no ? this.assign_no.replaceAll("/", "_") : "";
    }
  },
  methods: {
    viewDoc(ufile) {
      if(!ufile) return;
      let key = "ASSIGNMENT_UPLOADS/" + this.doc_path + "/" + ufile;
      this.openSignedDocument(key);
    },
    getFormatDateTime() {
      // Parse the originalDateTime string into a JavaScript Date object
      // Set originalDateTime to the current date and time
      let originalDateTime = new Date();

      // Extract individual components (optional)
      const year = originalDateTime.getFullYear();
      const month = originalDateTime.getMonth() + 1; // January is 0
      const day = originalDateTime.getDate();
      const hour = originalDateTime.getHours();
      const minute = originalDateTime.getMinutes();

      // Format the date and time as "YYYYMMDDHHmm"
      const formattedDateTime = `${year}${month
        .toString()
        .padStart(2, "0")}${day.toString().padStart(2, "0")}${hour
        .toString()
        .padStart(2, "0")}${minute.toString().padStart(2, "0")}`;

      // Display the formatted date and time
      console.log(formattedDateTime); // Output: "202405021250"
      return formattedDateTime;
    },
    async handleFileChange(event) {
      this.files = [];
      const fileList = event.target.files;
      for (let i = 0; i < fileList.length; i++) {
        this.files.push({
          name: fileList[i].name,
          progress: 0,
          file: fileList[i],
        });
      }
      // },
      // uploadFiles() {
      const formData = new FormData();
      for (let i = 0; i < this.files.length; i++) {
        // formData.append(`file[${i}]`, this.files[i].file);
        formData.append("file[]", this.files[i].file);
        formData.append(
          "staticFileName",
          this.documentName +
            this.fileAllModuleId +
            "_FileLength_" +
            this.files.length +
            "_" +
            i +
            "_" +
            this.getFormatDateTime()
        );
        formData.append("upload_dir_folderName", this.assign_no.replaceAll("/", "_"));
      }
      axios
        .post(`${URL_BASE}/uploadFileCommonForAllTest31_05_2024.php`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
          onUploadProgress: (progressEvent) => {
            for (let i = 0; i < this.files.length; i++) {
              this.files[i].progress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
            }
          },
        })
        .then(async (response) => {
          console.log("response=>", response);
          this.fileData = "";
          this.fileData = response.data;
          // this.$emit('fileuploaded', fileData);
          // const fileData = {
          //   name: file.name,
          //   size: file.size,
          //   url: response.url
          // };
          this.presignedUrls = response.data.presignedUrlArr;
          this.uploadedFiles = response.data.imgPath.split(",");
          eventBus.$emit("fileuploaded", response.data.imgPath);
          // eventBus.$emit("fileuploaded", this.fileData);
          eventBus.$emit("fileuploadedindex", this.index);
          let indexObj = {
            index: this.index,
            second_index: this.second_index,
          };
          eventBus.$emit("fileuploadedsecondindex", indexObj);
          this.fileEvent = "";
          await this.uploadFiles();
          console.log("Files uploaded successfully");
        })
        .catch((error) => {
          console.error(error);
          console.log("Retrying upload...");
          // this.handleFileChange(file);
          setTimeout(() => {
            this.handleFileChange(this.fileEvent);
          }, 10000); // Retry after 3 seconds
        })
        .finally(() => {
          // uploadLoader.hide();
        });
    },
    async uploadFiles() {
      try {
        // Iterate through files and upload each one using the corresponding pre-signed URL
        for (let i = 0; i < this.files.length; i++) {
          const file = this.files[i].file;
          const presignedUrl = this.presignedUrls[i];

          // Perform file upload using Axios PUT request
          await this.uploadFileToS3(file, presignedUrl, i);
        }
      } catch (error) {
        console.error("Error uploading files:", error);
      }
    },
    uploadFileToS3(file, presignedUrl, i) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("PUT", presignedUrl, true);
        xhr.setRequestHeader("Content-Type", file.type);

        xhr.upload.onprogress = (event) => {
          if (event.lengthComputable) {
            const progress = (event.loaded / event.total) * 100;
            file.progress = Math.round(progress);
          }
        };

        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve();
            // this.CopyAWSToServer();
          } else {
            reject(`Upload failed with status ${xhr.status}`);
          }
        };

        xhr.onerror = () => {
          reject("Upload failed due to network error.");
        };

        xhr.send(file);
      });
    },
    updateFileProgress(index, progress) {
      this.files[index].progress = progress;
    },


  },
};
</script>

<style>
.progress-bar {
  height: 10px;
  background-color: #ddd;
  width: 100%;
}
.progress-bar > div {
  height: 100%;
  background-color: #007bff;
}
</style>



// WEBPACK FOOTER //
// singleUpload.vue?2069a588